import { render, staticRenderFns } from "./FormBuy.vue?vue&type=template&id=8934a3f4&"
import script from "./FormBuy.vue?vue&type=script&lang=js&"
export * from "./FormBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports